<template>
  <div class="fans-page">
    <div class="tab-box">
      <ul class="tab-btn-list" ref="tabsContainer">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.name === currentMenu}" ref="tabs">
          <router-link :to="{name: tab.name}">
            {{tab.title}}
          </router-link>
        </li>
      </ul>
    </div>
    <ListView :current-menu="currentMenu" class="container" />
  </div>
</template>

<script>
import ListView from '@/components/Fans/ListView.vue';

export default {
  name: 'FansView',
  components: {
    ListView,
  },
  data() {
    return {
      tabList: [],
    }
  },
  computed: {
    currentMenu() {
      return this.$route.name;
    }
  },
  watch: {
    // 라우트 변경 감지
    '$route' (to, from) {
      this.ensureActiveTabVisible();
    }
  },
  created() {
    this.initializeTabs();
  },
  mounted () {
    this.$nextTick(() => {
      this.ensureActiveTabVisible();
    });
  },
  methods: {
    initializeTabs() {
      const menuList = this.$router.options.routes.filter(x => x.path === this.$route.matched[0].path);
      const subMenuList = menuList[0]?.children?.filter(x => x.meta && x.meta.title) || [];

      this.tabList = subMenuList.map(({ meta: { title }, name }) => ({
        title,
        name,
        isActive: this.$route.name === name
      }));
    },
    ensureActiveTabVisible() {
      const activeTabIndex = this.tabList.findIndex(tab => tab.name === this.currentMenu);
      if (activeTabIndex !== -1) {
        this.scrollToCenter(activeTabIndex);
      }
    },
    scrollToCenter(index) {
      this.$nextTick(() => {
        const tabElement = this.$refs.tabs[index];
        const containerElement = this.$refs.tabsContainer;

        if (tabElement && containerElement) {
          const leftOffset = tabElement.offsetLeft;
          const width = tabElement.offsetWidth;
          const containerWidth = containerElement.offsetWidth;
          const scrollPosition = leftOffset - (containerWidth / 2) + (width / 2);

          containerElement.scroll({
            left: scrollPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  }
}
</script>
